import { Row, Col } from "react-bootstrap";
import { useSelector } from "react-redux";
import "./styles.scss";
import { HiOutlineUserGroup } from "react-icons/hi2";
import { BsPersonVideo3 } from "react-icons/bs";
import { PiBuildingOffice } from "react-icons/pi";
import { useEffect, useState } from "react";
import { GET } from "../../utils/apiCalls";
import API from "../../config/api";
import { Button, message } from "antd";
import DataTable from "./dataTable";
import Graph from "./graph";
import BarChart from "./barChart";
import { useNavigate } from "react-router-dom";
import Loading from "../../components/loading";
import {
  MdCoPresent,
  MdOutlineBlock,
  MdOutlineCoPresent,
  MdOutlineMeetingRoom,
  MdOutlineNoMeetingRoom,
} from "react-icons/md";
import { SlHourglass, SlPeople } from "react-icons/sl";
import { FaCheckCircle, FaTimesCircle } from "react-icons/fa"; // New icons for attended/absent
import UpcomingMeetings from "./MeetingTable";

function DashboardScreen() {
  const navigate = useNavigate();
  const [data, setData] = useState([]) as any;
  const [isLoading, setIsLoading] = useState(false);

  const Events = useSelector((state: any) => state.Events);
  const User = useSelector((state: any) => state.User?.user);
  useEffect(() => {
    if (Events.defult?.id) {
      loadData();
    } else {
      navigate("/company/events?page=1&limit=6");
    }
  }, [Events.defult?.id]);

  const loadData = async () => {
    try {
      setIsLoading(true);
      let url = API.DASHBOARD_LIST + `/${Events.defult?.id}`;
      let res: any = await GET(url, null);
      if (res.status) {
        setData(res.data);
      } else {
        message.error("Something went wrong...!");
      }
    } catch (error) {
      console.log("error", error);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div>
      {isLoading ? (
        <Loading />
      ) : (
        <>
          <Row>
            <Col md={4} xs={12}>
              <div className="DashboardScreen-box">
                <div
                  className="DashboardScreen-box2"
                  onClick={() => navigate("/company/meetings?page=1&limit=10")}
                >
                  <div>
                    <div className="DashboardScreen-text1">
                      {data?.totalMeetings}
                    </div>
                    <div style={{ margin: 10 }} />
                    <div className="DashboardScreen-text2">Total Meetings</div>
                  </div>
                  <div>
                    <HiOutlineUserGroup size={25} color="#598cd9" />
                  </div>
                </div>
              </div>
            </Col>
            <Col md={4} xs={12}>
              <div
                className="DashboardScreen-box"
                onClick={() =>
                  navigate(`/company/meetings?page=1&limit=10&start=${true}`)
                }
              >
                <div className="DashboardScreen-box2">
                  <div>
                    <div className="DashboardScreen-text1">
                      {data?.totalStartMeetings}
                    </div>
                    <div style={{ margin: 10 }} />
                    <div className="DashboardScreen-text2">
                      Total Started Meetings
                    </div>
                  </div>
                  <div>
                    <SlHourglass size={25} color="#598cd9" />
                  </div>
                </div>
              </div>
            </Col>
            <Col md={4} xs={12}>
              <div
                className="DashboardScreen-box"
                onClick={() =>
                  navigate(`/company/meetings?page=1&limit=10&pending=${true}`)
                }
              >
                <div className="DashboardScreen-box2">
                  <div>
                    <div className="DashboardScreen-text1">
                      {data?.totalNotStartMeetings}
                    </div>
                    <div style={{ margin: 10 }} />
                    <div className="DashboardScreen-text2">
                      Total Pending Meetings
                    </div>
                  </div>
                  <div>
                    <MdOutlineBlock size={25} color="#598cd9" />
                  </div>
                </div>
              </div>
            </Col>
            <Col md={4} xs={12}>
              <div
                className="DashboardScreen-box"
                onClick={() => navigate("/company/investors?page=1&limit=10")}
              >
                <div className="DashboardScreen-box2">
                  <div>
                    <div className="DashboardScreen-text1">
                      {data?.TotalInvestors}
                    </div>
                    <div style={{ margin: 10 }} />
                    <div className="DashboardScreen-text2">
                      Total Corporates
                    </div>
                  </div>
                  <div>
                    <BsPersonVideo3 size={25} color="#598cd9" />
                  </div>
                </div>
              </div>
            </Col>
            <Col md={4} xs={12}>
              <div
                className="DashboardScreen-box"
                onClick={() =>
                  navigate("/company/investors?nomeeting=true&page=1&limit=10")
                }
              >
                <div className="DashboardScreen-box2">
                  <div>
                    <div className="DashboardScreen-text1">
                      {data?.totalInvestorsWithoutMeating}
                    </div>
                    <div style={{ margin: 10 }} />
                    <div className="DashboardScreen-text2">
                      Corporates without meetings
                    </div>
                  </div>
                  <div>
                    <SlPeople size={25} color="#598cd9" />
                  </div>
                </div>
              </div>
            </Col>
            <Col md={4} xs={12}>
              <div
                className="DashboardScreen-box"
                onClick={() =>
                  navigate("/company/investors?noroom=true&page=1&limit=10")
                }
              >
                <div className="DashboardScreen-box2">
                  <div>
                    <div className="DashboardScreen-text1">
                      {data?.totalInvestorsWithoutRoom}
                    </div>
                    <div style={{ margin: 10 }} />
                    <div className="DashboardScreen-text2">
                      Corporates without meeting rooms
                    </div>
                  </div>
                  <div>
                    <MdOutlineNoMeetingRoom size={25} color="#598cd9" />
                  </div>
                </div>
              </div>
            </Col>
            <Col md={4} xs={12}>
              <div
                className="DashboardScreen-box"
                onClick={() => navigate("/company/startups?page=1&limit=10")}
              >
                <div className="DashboardScreen-box2">
                  <div>
                    <div className="DashboardScreen-text1">
                      {data?.totalStartups}
                    </div>
                    <div style={{ margin: 10 }} />
                    <div className="DashboardScreen-text2">Total Startups</div>
                  </div>
                  <div>
                    <PiBuildingOffice size={25} color="#598cd9" />
                  </div>
                </div>
              </div>
            </Col>
            <Col md={4} xs={12}>
              <div
                className="DashboardScreen-box"
                onClick={() => navigate("/company/rooms?page=1&limit=10")}
              >
                <div className="DashboardScreen-box2">
                  <div>
                    <div className="DashboardScreen-text1">
                      {data?.totalRooms}
                    </div>
                    <div style={{ margin: 10 }} />
                    <div className="DashboardScreen-text2">Total Rooms</div>
                  </div>
                  <div>
                    <MdOutlineMeetingRoom size={25} color="#598cd9" />
                  </div>
                </div>
              </div>
            </Col>
            <Col md={4} xs={12}>
              <div
                className="DashboardScreen-box"
                onClick={() =>
                  navigate("/company/rooms?page=1&limit=10&available=false")
                }
              >
                <div className="DashboardScreen-box2">
                  <div>
                    <div className="DashboardScreen-text1">
                      {data?.totalFreeRooms}
                    </div>
                    <div style={{ margin: 10 }} />
                    <div className="DashboardScreen-text2">
                      Total Available Rooms
                    </div>
                  </div>
                  <div>
                    <MdOutlineMeetingRoom size={25} color="#598cd9" />
                  </div>
                </div>
              </div>
            </Col>
            {/* New Cards */}
            <Col md={4} xs={12}>
              <div
                className="DashboardScreen-box"
                onClick={() =>
                  navigate("/company/investors?attended=true&page=1&limit=10")
                }
              >
                <div className="DashboardScreen-box2">
                  <div>
                    <div className="DashboardScreen-text1">
                      {data?.totalCorporatesAttended}
                    </div>
                    <div style={{ margin: 10 }} />
                    <div className="DashboardScreen-text2">
                      Total Corporates Checked In
                    </div>
                  </div>
                  <div>
                    <MdCoPresent size={25} color="#598cd9" />
                  </div>
                </div>
              </div>
            </Col>
            <Col md={4} xs={12}>
              <div
                className="DashboardScreen-box"
                onClick={() =>
                  navigate("/company/investors?attended=false&page=1&limit=10")
                }
              >
                <div className="DashboardScreen-box2">
                  <div>
                    <div className="DashboardScreen-text1">
                      {data?.totalCorporatesAbsent}
                    </div>
                    <div style={{ margin: 10 }} />
                    <div className="DashboardScreen-text2">
                      Total Corporates Chcked out
                    </div>
                  </div>
                  <div>
                    <MdOutlineCoPresent size={25} color="#598cd9" />
                  </div>
                </div>
              </div>
            </Col>
            <Col md={4} xs={12}>
              <div
                className="DashboardScreen-box"
                onClick={() =>
                  navigate("/company/startups?attended=true&page=1&limit=10")
                }
              >
                <div className="DashboardScreen-box2">
                  <div>
                    <div className="DashboardScreen-text1">
                      {data?.totalStartupsAttended}
                    </div>
                    <div style={{ margin: 10 }} />
                    <div className="DashboardScreen-text2">
                      Total Startups Checked In
                    </div>
                  </div>
                  <div>
                    <MdCoPresent size={25} color="#598cd9" />
                  </div>
                </div>
              </div>
            </Col>
            <Col md={4} xs={12}>
              <div
                className="DashboardScreen-box"
                onClick={() =>
                  navigate("/company/startups?attended=false&page=1&limit=10")
                }
              >
                <div className="DashboardScreen-box2">
                  <div>
                    <div className="DashboardScreen-text1">
                      {data?.totalStartupsAbsent}
                    </div>
                    <div style={{ margin: 10 }} />
                    <div className="DashboardScreen-text2">
                      Total Startups Checked out
                    </div>
                  </div>
                  <div>
                    <MdOutlineCoPresent size={25} color="#598cd9" />
                  </div>
                </div>
              </div>
            </Col>
            <Col md={4} xs={12}>
            <div
              className="DashboardScreen-box"
              onClick={() =>
                navigate("/company/meetings?page=1&limit=10&statusFilter=vc_not_in")
              }
            >
              <div className="DashboardScreen-box2">
                <div>
                  <div className="DashboardScreen-text1">
                    {data?.totalCorporatesNotCheckedIn}
                  </div>
                  <div style={{ margin: 10 }} />
                  <div className="DashboardScreen-text2">
                    Total Corporates Not Yet Checked In
                  </div>
                </div>
                <div>
                  <FaTimesCircle size={25} color="#598cd9" />
                </div>
              </div>
            </div>
          </Col>

          <Col md={4} xs={12}>
            <div
              className="DashboardScreen-box"
              onClick={() =>
                navigate("/company/meetings?page=1&limit=10&statusFilter=su_not_in")
              }
            >
              <div className="DashboardScreen-box2">
                <div>
                  <div className="DashboardScreen-text1">
                    {data?.totalStartupsNotCheckedIn}
                  </div>
                  <div style={{ margin: 10 }} />
                  <div className="DashboardScreen-text2">
                    Total Startups Not Yet Checked In
                  </div>
                </div>
                <div>
                  <FaTimesCircle size={25} color="#598cd9" />
                </div>
              </div>
            </div>
          </Col>

          </Row>
          <br />
            {data.upcomingMeetings?.length  ? (
              <>
          <div className="DashboardScreen-row">
          <h4 className="DashboardScreen-text1">
            Upcoming Meetings on{" "}
            {Events?.defult?.event_date
              ? new Date(Events.defult.event_date).toLocaleDateString("en-US", {
                  weekday: "long",   
                  month: "long",    
                  day: "numeric",
                  year: "numeric",  
                })
              : ""}
          </h4>
          <div style={{ flex: 1 }} />
            <div>
              <Button
                type="link"
                size="small"
                onClick={() => navigate("/company/meetings?page=1&limit=10&sortBy=slot&sortOrder=ASC")}
              >
                See More {">"}
              </Button>
          </div>
            </div> 
          <div style={{ margin: 15 }} />
          <div className="DashboardScreen-box" style={{ padding: 0 }}>
            <UpcomingMeetings data={data.upcomingMeetings} />

          </div>
          </>
          
          ) : null }
          <Row>
            <Col md={6} xs={12}>
              <div className="DashboardScreen-row">
                <h4 className="DashboardScreen-text1">
                  Daily Corporates Registration
                </h4>
              </div>
              <div style={{ margin: 15 }} />
              <Graph data={data?.investorsGraph} />
            </Col>
            <Col md={6} xs={12}>
              <div className="DashboardScreen-row">
                <h4 className="DashboardScreen-text1">Daily Statistics</h4>
              </div>
              <div style={{ margin: 15 }} />
              <BarChart data={data} />
            </Col>
          </Row>
          <div className="DashboardScreen-row">
            <h4 className="DashboardScreen-text1">Recently Registered Corporates</h4>
            <div style={{ flex: 1 }} />
            <div>
            {Array.isArray(User.access[Events?.defult?.id]) &&
            User.access[Events?.defult?.id].includes(8) ? null :
              <Button
                type="link"
                size="small"
                onClick={() => navigate("/company/investors?page=1&limit=10")}
              >
                See More {">"}
              </Button>
              }
            </div>
          </div>
          <div style={{ margin: 15 }} />
          <div className="DashboardScreen-box" style={{ padding: 0 }}>
            <DataTable data={data} />
          </div>
        </>
      )}
      <br />
    </div>
  );
}

export default DashboardScreen;